export const MODELS = ["msrp", "reseller", "sp"];
export const MODEL_LABEL = { msrp: "MSRP", reseller: "Reseller", sp: "SP" };
export const PH = 9999;

export const fmtPrice = (p) => {
  if (p === null || p === undefined || p === "") return "—";
  const n = Number(p);
  const dec = Math.min(4, Math.max(2, (String(n).split(".")[1] || "").length));
  return `$${n.toLocaleString("en-CA", { minimumFractionDigits: dec, maximumFractionDigits: dec })}`;
};

export const isPh = (c) => !!c && !c.na && Number(c.price) >= PH;

// 1st-of-month dates at least `notice` days after `today` (YYYY-MM-DD strings).
export function validDates(today, notice = 30, count = 12) {
  const min = new Date(`${today}T00:00:00`);
  min.setDate(min.getDate() + notice);
  const d = new Date(min.getFullYear(), min.getMonth(), 1);
  if (d < min) d.setMonth(d.getMonth() + 1);
  return Array.from({ length: count }, (_, i) => {
    const x = new Date(d.getFullYear(), d.getMonth() + i, 1);
    return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-01`;
  });
}

export const groupByCategory = (items) => {
  const out = [];
  for (const it of items) {
    const last = out[out.length - 1];
    if (!last || last.category !== it.category) out.push({ category: it.category, items: [it] });
    else last.items.push(it);
  }
  return out;
};
